import { relations } from "drizzle-orm";
import { pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { user } from "../better-auth/auth-schema";

export const onboarding = pgTable("onboarding", {
  id: uuid("id").primaryKey().defaultRandom(),
  userId: text("user_id")
    .notNull()
    .references(() => user.id, { onDelete: "cascade" })
    .unique(),
  referralSource: text("referral_source"),
  companySize: text("company_size"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const onboardingRelations = relations(onboarding, ({ one }) => ({
  user: one(user, {
    fields: [onboarding.userId],
    references: [user.id],
  }),
}));
